import Swiper from "swiper/bundle";

export const Stories = () => {
  const $stories = document.querySelector("section.stories");
  if ($stories) {
    const $storiesContents = $stories.querySelector(".stories__contents");

    const $wrapperInfo = $storiesContents?.querySelector(".contents__info");

    const $infoNav = $wrapperInfo?.querySelector(".info__nav");
    const $navLeft = $infoNav?.querySelector(".nav__left");
    const $navRight = $infoNav?.querySelector(".nav__right");

    const $wrapperSwiper = $storiesContents.querySelector(
      ".contents__swiper.swiper"
    );
    if ($wrapperSwiper) {
      const swiperConfig = {
        direction: "horizontal",
        speed: 1000,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            slidesPerGroupAuto: true,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            slidesPerGroupAuto: true,
            spaceBetween: 24,
          },
        },
      };
      if ($infoNav) {
        const $infoNavButtonPrev = $infoNav.querySelector(
          ".nav__button.nav__button--prev"
        );
        const $infoNavButtonNext = $infoNav.querySelector(
          ".nav__button.nav__button--next"
        );
        swiperConfig.navigation = {
          disabledClass: "nav__button--disabled",
          prevEl: $infoNavButtonPrev,
          nextEl: $infoNavButtonNext,
        };
      }
      const swiperObject = new Swiper($wrapperSwiper, swiperConfig);
    }

    const $slideVideos = $wrapperSwiper.querySelectorAll(".slide__video");
    $slideVideos.forEach(($slideVideo) => {
      const $videoVideo = $slideVideo.querySelector(".video__video");
      const $videoinfo = $slideVideo.querySelector(".video__info");
      const $playButton = $slideVideo.querySelector(".play__button");

      $playButton?.addEventListener("click", (event) => {
        event.preventDefault();
        $slideVideos.forEach(($slideVideoInner) => {
          const $videoVideoInner =
            $slideVideoInner.querySelector(".video__video");
          const $videoPlayInner =
            $slideVideoInner.querySelector(".video__info");
          const $playButtonInner =
            $slideVideoInner.querySelector(".play__button");
          $videoPlayInner.classList.remove("video__info--hidden");
          $videoPlayInner.classList.remove("hidden");
          $playButtonInner.classList.remove("play__button--hidden");
          $playButtonInner.classList.remove("hidden");
          $videoVideoInner.load();
        });

        if ($videoVideo.paused || $videoVideo.ended) {
          $videoinfo.classList.add("video__info--hidden");
          $videoinfo.classList.add("hidden");
          $playButton.classList.add("play__button--hidden");
          $playButton.classList.add("hidden");
          $videoVideo.play();
        } else {
          $videoinfo.classList.remove("video__info--hidden");
          $videoinfo.classList.remove("hidden");
          $playButton.classList.remove("play__button--hidden");
          $playButton.classList.remove("hidden");

          $videoVideo.load();
        }
      });

      $videoVideo.addEventListener("click", (event) => {
        $videoinfo.classList.remove("video__info--hidden");
        $videoinfo.classList.remove("hidden");
        $playButton.classList.remove("play__button--hidden");
        $playButton.classList.remove("hidden");
        $videoVideo.load();
      });

      $videoVideo.addEventListener("paused", (event) => {
        $videoinfo.classList.remove("video__info--hidden");
        $videoinfo.classList.remove("hidden");
        $playButton.classList.remove("play__button--hidden");
        $playButton.classList.remove("hidden");
        $videoVideo.load();
      });
      $videoVideo.addEventListener("ended", (event) => {
        $videoinfo.classList.remove("video__info--hidden");
        $videoinfo.classList.remove("hidden");
        $playButton.classList.remove("play__button--hidden");
        $playButton.classList.remove("hidden");
        $videoVideo.load();
      });
    });
  }
};

export default Stories;
